import cx from 'classnames';

export default (...args) => cx(...args) || null;
